export class QuoteRequestController {

    constructor($log, $http, AppConfig, UserSessionService, $analytics) {
        'ngInject';

        this.$log = $log;
        this.$http = $http;
        this.appConfig = AppConfig;
        this.userSessionService = UserSessionService;
        this.$analytics = $analytics;

        this.formData = {
            firstName: null,
            lastName: null,
            phone: null,
            email_address: null,
            postcode: null,
            comments: null
        };

        this.$analytics.pageTrack('/request-quote');
        this.$analytics.eventTrack('open', {category: 'request-quote-form'});
    }

    submit() {

        let data = _.pick(this.formData, ['first_name', 'last_name', 'phone', 'email_address', 'postcode', 'comments']);

        this.loading = true;

        this.userSessionService.requestQuote(data).then((response) => {
            this.loading = false;
            this.success = true;
            this.$analytics.pageTrack('/request-quote/complete');
            this.$analytics.eventTrack('submit', {category: 'Request quote'});
            this.$log.debug('success', response);
        }).catch((response) => {
            this.loading = false;
            this.errors = response.data;
            this.$analytics.eventTrack('invalid', {category: 'Request quote'});
            this.$log.debug('failed', response);
        });

    }

}



// WEBPACK FOOTER //
// ./src/js/components/quote-request/quote-request.controller.js